function canNodeBeSubmitted(questionValiditySet, questionCommands, questionViewModel) {
  var canNodeSubmit = false;
  /**
   * Get all of the required questions for a given `questionViewModel`
   */

  var requiredQuestionMap = questionViewModel.questions.filter(function (question) {
    return question.commonFields.required;
  });
  /**
   * Check to see if any questions have it into state yet. No questions
   * in state and no required questions means we can submit the node. No
   * need to proceed to other validations.
   */

  var questionCommandsEntries = Object.keys(questionCommands);

  if (questionCommandsEntries.length === 0 && requiredQuestionMap.length === 0) {
    return true;
  }
  /**
   * If we have any required questions, check to see that they have valid answers.
   */


  if (requiredQuestionMap.length > 0) {
    canNodeSubmit = requiredQuestionMap.every(function (requiredQuestion) {
      var _a;

      return (_a = questionValiditySet[requiredQuestion.id]) === null || _a === void 0 ? void 0 : _a.hasValidAnswer;
    });
    /**
     * If they don't, no need to further try to validate the remaining questions, these
     * need to be answered regardless of the other questions state.
     */

    if (!canNodeSubmit) {
      return false;
    }
  }
  /**
   * Lastly, our required questions are guarnateed to have valid answers, make sure that all questions
   * we've started (have a representation in `questionCommands`) answering are valid.
   */


  canNodeSubmit = questionCommandsEntries.every(function (questionCommandKey) {
    var _a;

    return (_a = questionValiditySet[questionCommandKey]) === null || _a === void 0 ? void 0 : _a.hasValidAnswer;
  });
  return canNodeSubmit;
}

export default canNodeBeSubmitted;
//# sourceMappingURL=canNodeBeSubmitted.js.map
